// import React, { useState } from "react";
// import "./Submit_Your_Review.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
// import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
// import Rating from "react-rating";
// import { Form } from "react-bootstrap";
// import Green_btn from "../../../../common-components/common_btn/green_btn/Green_btn";
// import Success_Modal from "../../../../common-components/common_modal/success_modal/Success_Modal";
// import { useForm, Controller } from "react-hook-form";
// import { useDispatch, useSelector } from "react-redux";
// import { postRating } from "../../../../../features/rating/ratingSlice";
// import Set_New_Password_Modal from "../../../../common-components/common_modal/set_new_password_modal/Set_New_Password_Modal";
// import Reset_Password_Modal from "../../../../common-components/common_modal/reset_password_modal/Reset_Password_Modal";
// import Login_Modal from "../../../../common-components/common_modal/login_modal/Login_Modal";
// import { allReviewRating, AvgReviewRating } from "../../../../../features/review_rating/review_ratingSlice";

// function Submit_Your_Review({ doctor }) {
//   const [modalShow, setModalShow] = React.useState(false);
//   const [images, setImages] = useState([]);

//   const handleImageChange = (e) => {
//     const files = Array.from(e.target.files);
//     setImages(files);
//   };
//   const {
//     register,
//     handleSubmit,
//     control,
//     formState: { errors },
//     reset,
//   } = useForm({
//     defaultValues: {
//       name: "",
//       email: "",
//       review: "",
//       rating: "",
//     },
//   });
//   const dispatch = useDispatch();
//   const onSubmit = async (d) => {
//     const formData = new FormData();

//     formData.append("ratings", d.ratings);
//     formData.append("review", d.review);
//     formData.append("doctor_id", doctor?.id);

//     images.forEach((img, index) => {
//       formData.append(`image${index}`, img);
//     });

//     formData.append("imageCount", images.length);

//     const res = await dispatch(postRating(formData));

//     if (res.meta?.requestStatus === "fulfilled") {
//       setModalShow(true);
//       reset();
//       setImages([]);

//       dispatch(
//         AvgReviewRating({
//           doctor_id: doctor.id,
//         })
//       );

//       dispatch(
//         allReviewRating({
//           doctor_id: doctor.id,
//         })
//       );
//     }
//   };

//   const isSignin = useSelector((state) => state.auth.is_signin);
//   const [email, setEmail] = useState();
//   const [contact, setContact] = useState();
//   const [showResetModal, setShowResetModal] = useState(false);
//   const [showSetPassModal, setShowSetPassModal] = useState(false);
//   const [showSuccessModal, setShowSucsessModal] = useState(false);
//   const [showAccountCreted, setShowAccountCreted] = useState(false);
//   const [showLoginModal, setShowLoginModal] = useState(false);
//   return (
//     <>
//       <section className="Submit_Your_Review">
//         <div className="heading_holder">
//           <h4>Submit Your Review</h4>
//           <p>Add Your Rating</p>

//           <Controller
//             name="ratings"
//             control={control}
//             rules={{ required: "Rating is required" }}
//             render={({ field }) => (
//               <div>
//                 <Rating
//                   {...field}
//                   initialRating={field.value}
//                   onChange={field.onChange}
//                   emptySymbol={<FontAwesomeIcon icon={farStar} color="#ccc" />}
//                   fullSymbol={
//                     <FontAwesomeIcon icon={fasStar} color="#FFD700" />
//                   }
//                   fractions={2}
//                 />
//                 {errors.ratings && (
//                   <p className="text-danger mt-1">{errors.ratings.message}</p>
//                 )}
//               </div>
//             )}
//           />
//         </div>

//         <div className="form_holder">
//           <Form>
//             <div className="row">
//               {/* <div className="col-md-6">
//                 <Form.Group className="input_group">
//                   <Form.Control
//                     type="text"
//                     placeholder="Add Name"
//                     {...register("name", { required: "Name is required" })}
//                   />
//                   {errors.name && (
//                     <p className="text-danger mt-1">{errors.name.message}</p>
//                   )}
//                 </Form.Group>
//               </div>

//               <div className="col-md-6">
//                 <Form.Group className="input_group">
//                   <Form.Control
//                     type="text"
//                     placeholder="Email Address"
//                     {...register("email", {
//                       required: "Email is required",
//                       pattern: {
//                         value: /^\S+@\S+$/i,
//                         message: "Invalid email format",
//                       },
//                     })}
//                   />
//                   {errors.email && (
//                     <p className="text-danger mt-1">{errors.email.message}</p>
//                   )}
//                 </Form.Group>
//               </div> */}

//               <div className="col-md-12">
//                 <Form.Group className="input_group">
//                   <input
//                     type="file"
//                     multiple
//                     accept="image/*"
//                     onChange={handleImageChange}
//                   />

//                 </Form.Group>
//               </div>

//               <div className="col-md-12">
//                 <Form.Group className="input_group">
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     placeholder="Write review..."
//                     {...register("review", {
//                       required: "Review is required",
//                     })}
//                   />
//                   {errors.review && (
//                     <p className="text-danger mt-1">{errors.review.message}</p>
//                   )}
//                 </Form.Group>
//               </div>
//               {isSignin && (
//                 <div className="col-md-12">
//                   <div className="btn_holder">
//                     <Green_btn
//                       btnText={"Submit Review"}
//                       onClick={handleSubmit(onSubmit)}
//                     />
//                   </div>
//                 </div>
//               )}
//               {!isSignin && (
//                 <div className="col-md-12">
//                   <div className="btn_holder">
//                     <Green_btn
//                       btnText={"Submit Review"}
//                       onClick={() => {
//                         setShowLoginModal(true);
//                       }}
//                     />
//                   </div>
//                 </div>
//               )}
//             </div>
//           </Form>
//         </div>
//       </section>

//       <Login_Modal
//         show={showLoginModal}
//         onHide={() => {
//           setShowLoginModal(false);
//         }}
//         setShowResetModal={() => setShowResetModal(true)}
//         setShowAccountCreted={() => setShowAccountCreted(true)}
//       />

//       <Reset_Password_Modal
//         email={email}
//         setEmail={setEmail}
//         contact={contact}
//         setContact={setContact}
//         show={showResetModal}
//         onHide={() => {
//           setShowResetModal(false);
//         }}
//         setShowSetPassModal={() => setShowSetPassModal(true)}
//       />

//       <Set_New_Password_Modal
//         email={email}
//         setEmail={setEmail}
//         contact={contact}
//         setContact={setContact}
//         show={showSetPassModal}
//         onHide={() => {
//           setShowSetPassModal(false);
//         }}
//         setShowSucsessModal={() => setShowSucsessModal(true)}
//       />

//       <Success_Modal
//         show={showSuccessModal}
//         onHide={() => {
//           setShowSucsessModal(false);
//         }}
//         successText="Password Reseted Successfully!"
//       />

//       <Success_Modal
//         show={showAccountCreted}
//         onHide={() => {
//           setShowAccountCreted(false);
//         }}
//         successText="Account Created Successful!"
//       />

//       <Success_Modal
//         show={modalShow}
//         onHide={() => setModalShow(false)}
//         successText="Submitted Successfully!"
//       />
//     </>
//   );
// }

// export default Submit_Your_Review;

import React, { useState } from "react";
import "./Submit_Your_Review.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
import Rating from "react-rating";
import { Form, Modal } from "react-bootstrap";
import Green_btn from "../../../../common-components/common_btn/green_btn/Green_btn";
import Success_Modal from "../../../../common-components/common_modal/success_modal/Success_Modal";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { postRating } from "../../../../../features/rating/ratingSlice";
import Set_New_Password_Modal from "../../../../common-components/common_modal/set_new_password_modal/Set_New_Password_Modal";
import Reset_Password_Modal from "../../../../common-components/common_modal/reset_password_modal/Reset_Password_Modal";
import Login_Modal from "../../../../common-components/common_modal/login_modal/Login_Modal";
import {
  allReviewRating,
  AvgReviewRating,
} from "../../../../../features/review_rating/review_ratingSlice";
import {
  allDoctorRating,
  AvgDoctorRating,
  doctorReviewPost,
} from "../../../../../features/doctor_rating/doctor_ratingSlice";

function Submit_Your_Review({ doctor, show, onHide }) {
  const [modalShow, setModalShow] = useState(false);
  const [images, setImages] = useState([]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
  };

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      review: "",
      ratings: "",
    },
  });

  const dispatch = useDispatch();

  const onSubmit = async (d) => {
    const formData = new FormData();

    formData.append("ratings", d.ratings);
    formData.append("review", d.review);
    formData.append("doctor_id", doctor?.id);

    images.forEach((img, index) => {
      formData.append(`image${index}`, img);
    });

    formData.append("imageCount", images.length);

    const res = await dispatch(doctorReviewPost(formData));

    if (res.meta?.requestStatus === "fulfilled") {
      setModalShow(true);

      reset();
      setImages([]);

      await dispatch(
        AvgDoctorRating({
          doctor_id: doctor.id,
        }),
      );

      await dispatch(
        allDoctorRating({
          doctor_id: doctor.id,
        }),
      );

      onHide();
    }
  };

  const isSignin = useSelector((state) => state.auth.is_signin);

  const [email, setEmail] = useState();
  const [contact, setContact] = useState();
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  return (
    <>
  <Modal
  show={show}
  onHide={onHide}
  centered
  className="Submit_Review_Modal modal-xl"
>
  <button
    type="button"
    className="review_close_btn"
    onClick={onHide}
    aria-label="Close"
  >
    ×
  </button>

  <Modal.Body>
          <section className="Submit_Your_Review">
            <div className="heading_holder">
              <h4>Write a review</h4>
            </div>

            <div className="form_holder">
              <Form>
                <div className="row">
                  <div className="col-md-12">
                    <Form.Group className="input_group">
                      <Form.Control
                        as="textarea"
                        rows={3}
                        maxLength={200}
                        placeholder="Write your review here"
                        {...register("review", {
                          required: "Review is required",
                          maxLength: {
                            value: 200,
                            message: "Review cannot exceed 200 characters",
                          },
                        })}
                      />

                      <div className="d-flex justify-content-between align-items-center mt-1">
                        {errors.review ? (
                          <p className="text-danger mb-0">
                            {errors.review.message}
                          </p>
                        ) : (
                          <span></span>
                        )}

                        <small className="text-muted">
                          {watch("review")?.length || 0}/200
                        </small>
                      </div>
                    </Form.Group>
                  </div>

                  {/* <div className="col-md-12 review_action_wrapper">
                    <Controller
                      name="ratings"
                      control={control}
                      rules={{ required: "Rating is required" }}
                      render={({ field }) => (
                        <div className="rating_star_holder">
                          <Rating
                            {...field}
                            initialRating={field.value}
                            onChange={field.onChange}
                            emptySymbol={
                              <FontAwesomeIcon icon={farStar} color="#d9d9d9" />
                            }
                            fullSymbol={
                              <FontAwesomeIcon icon={fasStar} color="#f4b400" />
                            }
                            fractions={2}
                          />

                          {errors.ratings && (
                            <p className="text-danger mt-1">
                              {errors.ratings.message}
                            </p>
                          )}
                        </div>
                      )}
                    />
                    {isSignin && (
                      <div className="col-md-12">
                        <div className="btn_holder">
                          <Green_btn
                            btnText={"Post Now"}
                            onClick={handleSubmit(onSubmit)}
                          />
                        </div>
                      </div>
                    )}

                    {!isSignin && (
                      <div className="col-md-12">
                        <div className="btn_holder">
                          <Green_btn
                            btnText={"Post Now"}
                            onClick={() => setShowLoginModal(true)}
                          />
                        </div>
                      </div>
                    )}
                  </div> */}
                  <div className="review_action_wrapper">
                    <Controller
                      name="ratings"
                      control={control}
                      rules={{ required: "Rating is required" }}
                      render={({ field }) => (
                        <div className="rating_star_holder">
                          <Rating
                            {...field}
                            initialRating={field.value}
                            onChange={field.onChange}
                            emptySymbol={
                              <FontAwesomeIcon icon={farStar} color="#d9d9d9" />
                            }
                            fullSymbol={
                              <FontAwesomeIcon icon={fasStar} color="#f4b400" />
                            }
                            fractions={2}
                          />

                          {errors.ratings && (
                            <p className="text-danger mt-1">
                              {errors.ratings.message}
                            </p>
                          )}
                        </div>
                      )}
                    />

                    {isSignin ? (
                      <div className="btn_holder">
                        <Green_btn
                          btnText={"Post Now"}
                          onClick={handleSubmit(onSubmit)}
                        />
                      </div>
                    ) : (
                      <div className="btn_holder">
                        <Green_btn
                          btnText={"Post Now"}
                          onClick={() => setShowLoginModal(true)}
                        />
                      </div>
                    )}
                  </div>

                  {/* <div className="col-md-12">
                    <Form.Group className="input_group mt-3">
                      <input
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={handleImageChange}
                        className="form-control"
                      />
                    </Form.Group>
                  </div> */}
                </div>
              </Form>
            </div>
          </section>
        </Modal.Body>
      </Modal>

      <Login_Modal
        show={showLoginModal}
        onHide={() => {
          setShowLoginModal(false);
        }}
        setShowResetModal={() => setShowResetModal(true)}
        setShowAccountCreted={() => setShowAccountCreted(true)}
      />

      <Reset_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showResetModal}
        onHide={() => {
          setShowResetModal(false);
        }}
        setShowSetPassModal={() => setShowSetPassModal(true)}
      />

      <Set_New_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showSetPassModal}
        onHide={() => {
          setShowSetPassModal(false);
        }}
        setShowSucsessModal={() => setShowSucsessModal(true)}
      />

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Password Reseted Successfully!"
      />

      <Success_Modal
        show={showAccountCreted}
        onHide={() => {
          setShowAccountCreted(false);
        }}
        successText="Account Created Successful!"
      />

      <Success_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        successText="Submitted Successfully!"
      />
    </>
  );
}

export default Submit_Your_Review;
